import { atom, useAtom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { addDays, startOfDay, subDays } from 'date-fns';
import { buScopeKey, buScopeParams } from '@/lib/business-unit-scope';
import { selectedBusinessUnitIdAtom } from '@/stores/business-unit.store';
import { salesPerformanceService } from '@/services/sales-performance.service';

export const salesPerformanceRangeAtom = atom({ startDate: startOfDay(subDays(new Date(), 29)), endDate: startOfDay(new Date()) });
export const salesPerformanceCurrencyAtom = atom<string | undefined>(undefined);
const performanceQueryAtom = atomWithQuery((get) => {
  const range = get(salesPerformanceRangeAtom);
  const currency = get(salesPerformanceCurrencyAtom);
  const start = startOfDay(range.startDate).toISOString();
  const end = addDays(startOfDay(range.endDate), 1).toISOString();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    queryKey: ['sales-performance', buScopeKey(get), start, end, timezone, currency],
    queryFn: ({ signal }: { signal: AbortSignal }) => salesPerformanceService.get({ start, end, timezone, currency, ...buScopeParams(get) }, signal),
    enabled: Boolean(get(selectedBusinessUnitIdAtom)),
    staleTime: 24 * 60 * 60 * 1000,
    refetchInterval: 24 * 60 * 60 * 1000,
    retry: 1,
  };
});
export function useSalesPerformance() { return useAtomValue(performanceQueryAtom); }
export function useSalesPerformanceRange() { return useAtom(salesPerformanceRangeAtom); }
